import React, { useState, useEffect } from 'react';
import { useIdleTime } from './useIdleAlert';

/**
 * IdleAlert Component
 * 
 * Displays alerts when the user has been inactive for a specified period
 * Uses the useIdleTime hook to track user activity
 */
const IdleAlert = ({ threshold = 0.3, onDismiss }) => {
  const [visible, setVisible] = useState(false);
  const { idleTime, resetIdleTime } = useIdleTime();
  
  useEffect(() => {
    // Show alert when idle time exceeds threshold (in minutes)
    if (idleTime >= threshold) {
      setVisible(true);
    }
  }, [idleTime, threshold]);

  const handleDismiss = () => {
    setVisible(false);
    resetIdleTime();
    if (onDismiss) onDismiss();
  };

  const handleGetActive = () => {
    setVisible(false);
    resetIdleTime();
    // You could add navigation to workout suggestions here
  };

  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 bg-white rounded-lg shadow-lg p-4 max-w-md w-80 border-l-4 border-orange-500 z-50">
      <div className="flex items-start">
        <div className="flex-shrink-0 pt-0.5">
          <svg className="h-6 w-6 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div className="ml-3 w-0 flex-1">
          <p className="text-sm font-medium text-gray-900">Time to move!</p>
          <p className="mt-1 text-sm text-gray-500">
            You've been inactive for {threshold} minutes. A quick walk would be great for your health!
          </p>
          <div className="mt-4 flex">
            <button
              type="button"
              onClick={handleGetActive}
              className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Get Active
            </button>
            <button
              type="button"
              onClick={handleDismiss}
              className="ml-3 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdleAlert;